import React from 'react';
import { Responsive, Grid } from 'semantic-ui-react';

export default ({
  avatar,
  message,
  author,
  className
}: {
  avatar: string;
  message: string;
  author: string;
  className?: string;
}) => {
  return (
    <div className={className}>
      <Responsive minWidth={1024}>
        <CardLarge avatar={avatar} message={message} author={author} />
      </Responsive>
      <Responsive minWidth={641} maxWidth={1023}>
        <CardMiddle avatar={avatar} message={message} author={author} />
      </Responsive>
      <Responsive maxWidth={640}>
        <CardMoblile avatar={avatar} message={message} author={author} />
      </Responsive>
    </div>
  );
};

const CardLarge = ({
  avatar,
  message,
  author
}: {
  avatar: string;
  message: string;
  author: string;
}) => {
  return (
    <Grid style={{ minHeight: 270 }}>
      <Grid.Row>
        <Grid.Column width={5}>
          <img alt="avatar" src={require(`../../assets/images/${avatar}`)} />
        </Grid.Column>
        <Grid.Column width={11}>
          <div className="recommend-message">{message}</div>
          <div className="recommend-author">{author}</div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const CardMiddle = ({
  avatar,
  message,
  author
}: {
  avatar: string;
  message: string;
  author: string;
}) => {
  return (
    <div style={{ minHeight: 440 }}>
      <div>
        <img alt="avatar" src={require(`../../assets/images/${avatar}`)} />
      </div>
      <div style={{ padding: '20px 60px' }}>
        <div className="recommend-message">{message}</div>
        <div className="recommend-author">{author}</div>
      </div>
    </div>
  );
};

const CardMoblile = ({
  avatar,
  message,
  author
}: {
  avatar: string;
  message: string;
  author: string;
}) => {
  return (
    <div style={{ minHeight: 270 }}>
      <div>
        <img
          width="109"
          alt="avatar"
          src={require(`../../assets/images/${avatar}`)}
        />
      </div>
      <div style={{ padding: 20 }}>
        <div className="recommend-message">{message}</div>
        <div className="recommend-author">{author}</div>
      </div>
    </div>
  );
};
